module.exports = __webpack_public_path__ + "img/roles_8.2b0d85cd.png";